import { combineReducers } from "@reduxjs/toolkit";

import globalSlice from "./global.slice";
import BadgesSlice from "../pages/badges/services/slice";
import rewardSlice from "../pages/rewards/services/slice";
import StaticContent from "../pages/settings/services/slice";
import LibrarySlice from "../pages/my-library/services/slice";
import UserProfileSlice from "../pages/profile/services/slice";
import UserSupportSlice from "../pages/support/services/slice";
import RatingReviewSlice from "../pages/review/services/slice";
import StrainDetailsSlice from "../pages/strain/services/slice";
import SignInSlice from "../pages/user-authentication/services/slice";
import AnnouncementSlice from "../pages/announcements/services/slice";
import ProductDetailsSlice from "../pages/scan-product/services/slice";
import CompoundsListSlice from "../pages/compounds-list/services/slice";
import ProductChainSlice from "../pages/block-chain-view/services/slice";
import BrandDirectorySlice from "../pages/brand-directory/services/slice";
import ManufacturerDetailsSlice from "../pages/manufacture/services/slice";
import CompoundListingSlice from "../pages/compound-listing/services/slice";
import productCoASlice from "../pages/block-chain-coa-details/services/slice";

const rootReducer = combineReducers({
  rewardSlice: rewardSlice,
  badgesSlice: BadgesSlice,
  librarySlice: LibrarySlice,
  globalcontent: globalSlice,
  authentication: SignInSlice,
  staticContent: StaticContent,
  profileSlice: UserProfileSlice,
  productCoASlice: productCoASlice,
  userSupportSlice: UserSupportSlice,
  userProfileSlice: UserProfileSlice,
  announcementSlice: AnnouncementSlice,
  productChainSlice: ProductChainSlice,
  ratingReviewSlice: RatingReviewSlice,
  compoundsListSlice: CompoundsListSlice,
  strainDetailsSlice: StrainDetailsSlice,
  brandDirectorySlice: BrandDirectorySlice,
  compoundListingSlice: CompoundListingSlice,
  batchProductDetailsSlice: ProductDetailsSlice,
  manufacturerDetailsSlice: ManufacturerDetailsSlice,
});

export default rootReducer;
